/**
 * 去掉协议 HTML 内硬编码字色/背景色，使正文继承 `color-D` / `--text-1`，跟随亮暗主题。
 * （CMS 富文本常带 color:#000，暗色弹层下不可读）
 */
export function stripAgreementHtmlThemeColors(html: string): string {
  if (!html) return html;
  return (
    html
      // style="color:...; background-color:..."
      .replace(/\sstyle\s*=\s*(["'])([\s\S]*?)\1/gi, (_m, quote: string, style: string) => {
        const cleaned = style
          .replace(/(?:^|;)\s*(?:color|background(?:-color)?)\s*:[^;]*/gi, '')
          .replace(/^;+|;+$/g, '')
          .trim();
        if (!cleaned) return '';
        return ` style=${quote}${cleaned}${quote}`;
      })
      // <font color="..."> / bgcolor
      .replace(/\s(?:bg)?color\s*=\s*(["'])[\s\S]*?\1/gi, '')
      .replace(/\s(?:bg)?color\s*=\s*[^\s>]+/gi, '')
  );
}
